var _rect, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 35,
    height: 35,
    rx: 3.5,
    fill: "white",
    stroke: "#636799"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.5781 27.3586H10.7032C9.5654 27.3586 8.64062 26.4338 8.64062 25.296V14.4211C8.64062 13.2833 9.5654 12.3585 10.7032 12.3585H17.0781C17.3886 12.3585 17.6406 12.6105 17.6406 12.921C17.6406 13.2315 17.3886 13.4835 17.0781 13.4835H10.7032C10.1864 13.4835 9.76562 13.9043 9.76562 14.4211V25.296C9.76562 25.8128 10.1864 26.2336 10.7032 26.2336H21.5781C22.0949 26.2336 22.5157 25.8128 22.5157 25.296V18.9211C22.5157 18.6106 22.7677 18.3586 23.0782 18.3586C23.3887 18.3586 23.6407 18.6099 23.6407 18.9211V25.296C23.6407 26.4338 22.7159 27.3586 21.5781 27.3586Z",
    fill: "#636799"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2204 21.342C15.0726 21.342 14.9286 21.2835 14.8228 21.1771C14.6894 21.0443 14.6324 20.853 14.6692 20.6692L15.1994 18.0172C15.2211 17.9078 15.2751 17.808 15.3531 17.73L23.121 9.96303C23.9249 9.15897 25.2329 9.15897 26.0377 9.96303C26.4269 10.3522 26.6414 10.8698 26.6414 11.4211C26.6414 11.9723 26.4269 12.4898 26.0369 12.8791L18.2699 20.6468C18.1919 20.7255 18.0914 20.7788 17.9826 20.8005L15.3314 21.3307C15.2946 21.3383 15.2571 21.342 15.2204 21.342ZM17.8724 20.2493H17.8799H17.8724ZM16.2689 18.4051L15.9381 20.0625L17.5948 19.731L25.2419 12.0841C25.4189 11.9062 25.5164 11.6715 25.5164 11.4211C25.5164 11.1706 25.4189 10.9357 25.2419 10.758C24.8774 10.3927 24.2826 10.3927 23.916 10.758L16.2689 18.4051Z",
    fill: "#636799"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5778 14.1053C24.4339 14.1053 24.2898 14.0505 24.1804 13.9402L22.0593 11.8185C21.8396 11.5988 21.8396 11.2426 22.0593 11.0228C22.2791 10.8031 22.6353 10.8031 22.8551 11.0228L24.9761 13.1446C25.1958 13.3643 25.1958 13.7205 24.9761 13.9402C24.8658 14.0498 24.7219 14.1053 24.5778 14.1053Z",
    fill: "#636799"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditNew);
export default __webpack_public_path__ + "static/media/editNew.c011885e.svg";
export { ForwardRef as ReactComponent };